'use client';
import { useMemo } from 'react';

import { useHeight } from '@/hooks/use-height.hook';

export const useGridRows = (): number => {
  const height = useHeight();

  const rows = useMemo(() => {
    if (Number(height) > 850) {
      return 9;
    } else if (Number(height) > 750) {
      return 6;
    } else {
      return 4;
    }
  }, [height]);

  return rows;
};
